// extracted by mini-css-extract-plugin
export default {"social_proof":"SocialProof_social_proof__DpE8T"};